export default __webpack_public_path__ + "static/quadra-8a39d5f1bf8e41456dcbf55012172f01.jpg";